/* eslint-disable no-nested-ternary */
import React from "react";
import { isMobileOnly } from "react-device-detect";
import styles from "./TableView.module.css";
import TrashcanButton from "../TrashcanButton/TrashcanButton";
import StatusLabel from "../StatusLabel/StatusLabel";

const TableView = (props) => {
  const renderTableHead = () => {
    return props.colHeadings.map((heading) => {
      return <th key={heading}>{heading}</th>;
    });
  };

  const renderTableData = () => {
    return props.tableData.map((item, index) => {
      const header = Object.keys(props.tableData[0]).filter((k) => k !== "Id");
      return (
        <tr
          key={index}
          className={styles.clickable_row}
          tabIndex={0}
          role="button" // eslint-disable-line jsx-a11y/no-noninteractive-element-to-interactive-role
          onClick={() => props.onViewObjective(item.Id, item.Status)}
          onKeyDown={(e) =>
            e.key === "Enter" ? props.onViewObjective(item.Id, item.Status) : undefined
          }
        >
          {header.map((key, index2) => {
            let isDraft = false;
            if (item[key] === "Draft" && key === "Status") {
              isDraft = true;
            }
            let isLabel = false;
            if (item[key] === "Review required" && key === "Status" && !props.isLineManagerView) {
              isLabel = true;
            }
            if (
              (item[key] === "Pending approval" || item[key] === "Employee complete") &&
              key === "Status" &&
              props.isLineManagerView
            ) {
              isLabel = true;
            }
            let isBlankObjectiveName = false;
            if (key === "ObjectiveName") {
              if (!item[key]) {
                isBlankObjectiveName = true;
              }
            }
            let isBlankDueDate = false;
            if (key === "DueDate") {
              if (!item[key]) {
                isBlankDueDate = true;
              }
            }
            return (
              <td
                key={index2}
                name={item[key]}
                className={isDraft ? styles.delete_row : ""}
                style={{ width: "20%", height: "50px" }}
              >
                <div>
                  {isLabel ? (
                    <StatusLabel status={item[key]} />
                  ) : isBlankObjectiveName || isBlankDueDate ? (
                    <span className={styles.blank_item}>
                      {isBlankDueDate ? "No Date Selected" : "N/A"}
                    </span>
                  ) : (
                    item[key]
                  )}
                  {isDraft && !props.isLineManagerView && (
                    <TrashcanButton
                      id={`${item.Id}Delete`}
                      name={`${item.ObjectiveName}Delete`}
                      style={{ marginLeft: "10px", zIndex: 300 }}
                      onClick={(e) => {
                        e.stopPropagation();
                        props.onDeleteDraft(item.Id);
                      }}
                      onKeyDown={(e) => (e.key === "Enter" ? e.stopPropagation() : undefined)}
                    />
                  )}
                </div>
              </td>
            );
          })}
        </tr>
      );
    });
  };
  const renderMobileTableData = () => {
    return props.tableData.map((item) => {
      const header = Object.keys(props.tableData[0]).filter((k) => k !== "Id");
      const deleteDraft = () => {
        props.onDeleteDraft(item.id);
      };
      return (
        <>
          {header.map((key, index) => {
            let isDraft = false;
            if (item[key] === "Draft" && key === "Status") {
              isDraft = true;
            }
            let isLabel = false;
            if (item[key] === "Review required" && key === "Status" && !props.isLineManagerView) {
              isLabel = true;
            }
            if (
              (item[key] === "Pending approval" || item[key] === "Employee complete") &&
              key === "Status" &&
              props.isLineManagerView
            ) {
              isLabel = true;
            }
            return (
              <tr
                className={`${styles.mobile_row} ${styles.clickable_row}`}
                onClick={props.onViewObjective}
                role="button"
                name={item[key]}
                tabIndex={0}
                key={index}
              >
                <th className={key === "DateAdded" ? styles.mobile_objective_row : null}>
                  {key}:{" "}
                </th>
                <td
                  className={
                    item[key] === "DateAdded" // eslint-disable-line no-nested-ternary
                      ? styles.mobile_objective_row
                      : isDraft
                      ? styles.delete_row
                      : ""
                  }
                  style={{ width: "20%", zIndex: 300 }}
                >
                  {isLabel ? <StatusLabel status={item[key]} /> : item[key]}
                  {isDraft && (
                    <TrashcanButton
                      id={`${item.Id}Delete`}
                      name={`${item.ObjectiveName}Delete`}
                      style={{ marginLeft: "10px" }}
                      onClick={(e) => {
                        e.stopPropagation();
                        deleteDraft();
                      }}
                      onKeyDown={(e) => (e.key === "Enter" ? e.stopPropagation() : undefined)}
                    />
                  )}
                </td>
              </tr>
            );
          })}
        </>
      );
    });
  };

  const renderNoDataMessage = () => {
    return (
      <tr className={styles.empty_table}>
        <td colSpan="100%">{props.noDataMsg}</td>
      </tr>
    );
  };

  const renderTableRows = () => {
    return isMobileOnly ? renderMobileTableData() : renderTableData();
  };

  const renderTableBody = () => {
    return props.tableData.length !== 0 ? renderTableRows() : renderNoDataMessage();
  };

  return (
    <div className={styles.TableViewContainer}>
      <table className={styles.TableView}>
        <thead>
          <tr>{renderTableHead()}</tr>
        </thead>
        <tbody>{renderTableBody()}</tbody>
      </table>
    </div>
  );
};
export default TableView;
